var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-us"},[_c('Popup',{attrs:{"header":"Contact us"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }